import { render, staticRenderFns } from "./dialogPreventivo.html?vue&type=template&id=54a241e0&"
import script from "./DialogPreventivo.vue?vue&type=script&lang=js&"
export * from "./DialogPreventivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports